<template>
  <section :id="`uuid-${$attrs.uuid}`" :class='[classes, "banner-full"]'>
    <div class="banner-full-container section__container">
      <div class="section__wrapper">
        <picture class="banner-full__picture">
          <div class="banner-full__info-container">
            <h4 class="banner-full__title">{{title}}</h4>
            <div class="banner-full__paragraph" v-html='paragraph'></div>
            <span v-for="ctaObj in ctaLinks">
              <advanced-button-wrapper class= "btn-banner" :cta-obj="ctaObj" color="primary" styleType="text" size="medium" :analyticsData="analyticsData(ctaObj)"/>
            </span>
          </div>
            <source
              media="(min-width:0) and (max-width:640px)"
              :srcset="bannerFullImgMobile | mgnlMedia('url')"
              v-if="bannerFullImgMobile"
          />
          <source
              v-else
              media="(min-width:641px)"
              :srcset="bannerFullImgDesktop | mgnlMedia('url')"
          />
          <pg-image
              :lazy-src="mobileImage | mgnlMedia('url')"
              :alt="imageAlt"
          />
          <div :class="`banner-full__gradient ${ gradient }`"></div>
        </picture>
      </div>
<!--      <div :class="`hero-single-content__gradient ${ gradient.gradient }`"></div>-->
    </div>
  </section>
</template>

<script>
import PgImage from "../Image/Image.vue";
import advancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins";
export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "BannerFull",

  components: {
    advancedButtonWrapper,
    PgImage
  },

  props: {
    gradient : {
      type: String
    },
    ctaLinks: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    paragraph: {
      type: String,
      default: ''
    },
    bannerFullImgDesktop: {
      type: Object,
      default: () => {}
    },
    bannerFullImgMobile: {
      type: Object,
      default: () => {}
    },
    sectionStyle: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isMobile() {
      return window.matchMedia('only screen and (max-width: 640px)').matches;
    },
    mobileImage() {
      return this.isMobile ? this.bannerFullImgMobile : this.bannerFullImgDesktop;
    },
    imageAlt() {
      return this.isMobile ? this.bannerFullImgMobile.title : this.bannerFullImgDesktop.title;
    },
    classes() {
      return [
        "section",
        this.sectionStyle ? "section--" + this.sectionStyle : ''
      ];
    },
  },

  methods: {
    analyticsData(el) {
      return {
        evCategory: 'banner_full',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    }
  }
}
</script>